(function () {
  var scheduled = false;
  var observedWidgets = new WeakSet();
  var paginationStates = new WeakMap();
  var bootstrapObserver;
  var widgetObserver = new MutationObserver(scheduleEnhance);

  function reviewSignature(review) {
    if (!review) return '';
    return review.getAttribute('data-review-id') ||
      review.id ||
      [
        review.querySelector('.jdgm-rev__author')?.textContent,
        review.querySelector('.jdgm-rev__timestamp')?.textContent,
        review.querySelector('.jdgm-rev__title')?.textContent,
        review.querySelector('.jdgm-rev__body')?.textContent
      ].map(function (value) {
        return (value || '').replace(/\s+/g, ' ').trim();
      }).join('|');
  }

  function findNativeNext(paginate) {
    if (!paginate) return null;
    return paginate.querySelector('.jdgm-paginate__load-more:not(.cinoton-product-reviews__load-more), .jdgm-paginate__next-page');
  }

  function findReviewContainer(body) {
    return body && (body.querySelector('.jdgm-rev-widg__reviews') || body);
  }

  function resetPaginationState(root, failed) {
    var state = paginationStates.get(root);
    if (!state) return;
    window.clearTimeout(state.timer);
    paginationStates.delete(root);

    var widget = root.querySelector('.jdgm-rev-widg');
    var body = widget && widget.querySelector('.jdgm-rev-widg__body');
    var paginate = body && body.querySelector('.jdgm-paginate');
    var button = paginate && paginate.querySelector('.cinoton-product-reviews__load-more');
    if (paginate) paginate.removeAttribute('aria-busy');
    if (button) {
      button.disabled = false;
      button.textContent = failed ? 'Try Again' : 'Load More';
    }
  }

  function finishPaginationLoad(widget) {
    var root = widget.closest('.cinoton-product-reviews');
    var state = root && paginationStates.get(root);
    if (!state) return false;

    var body = widget.querySelector('.jdgm-rev-widg__body');
    var paginate = body && body.querySelector('.jdgm-paginate');
    if (!body || !paginate) return false;

    var reviewContainer = findReviewContainer(body);
    var currentReviews = Array.from(reviewContainer.querySelectorAll(':scope > .jdgm-rev'));
    var currentPageNode = paginate.querySelector('.jdgm-paginate__page.jdgm-curt');
    var currentPage = currentPageNode && Number(currentPageNode.dataset.page);
    var nextTarget = findNativeNext(paginate);
    var followingPage = nextTarget && Number(nextTarget.dataset.page);
    var pageAdvanced = currentPage === state.nextPage ||
      currentReviews.length > state.previousNodes.length ||
      (followingPage && followingPage > state.nextPage);

    if (!pageAdvanced || currentReviews.length === 0) return false;

    var currentSignatures = new Set(currentReviews.map(reviewSignature));
    var fragment = document.createDocumentFragment();
    state.previousNodes.forEach(function (review) {
      var signature = reviewSignature(review);
      if (!review.isConnected && !currentSignatures.has(signature)) {
        fragment.appendChild(review);
        currentSignatures.add(signature);
      }
    });

    if (fragment.childNodes.length) {
      reviewContainer.insertBefore(fragment, currentReviews[0]);
    }
    body.dataset.cinotonAccumulatedReviews = 'true';
    resetPaginationState(root, false);
    return true;
  }

  function beginPaginationLoad(button, widget) {
    var root = widget.closest('.cinoton-product-reviews');
    if (!root || paginationStates.has(root)) return;

    var body = button.closest('.jdgm-rev-widg__body');
    var paginate = button.closest('.jdgm-paginate');
    var nativeNext = findNativeNext(paginate);
    var nextPage = nativeNext && Number(nativeNext.dataset.page);
    if (!body || !nativeNext || !nextPage) return;

    var state = {
      nextPage: nextPage,
      previousNodes: Array.from(findReviewContainer(body).querySelectorAll(':scope > .jdgm-rev'))
    };
    paginationStates.set(root, state);
    paginate.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = 'Loading…';
    state.timer = window.setTimeout(function () {
      resetPaginationState(root, true);
    }, 12000);

    nativeNext.click();
  }

  function ensurePersistentPagination(widget) {
    finishPaginationLoad(widget);

    var body = widget.querySelector('.jdgm-rev-widg__body');
    var paginate = body && body.querySelector('.jdgm-paginate');
    if (!body || !paginate) return;

    paginate.classList.add('cinoton-product-reviews__paginate');
    var nativeNext = findNativeNext(paginate);
    var button = paginate.querySelector('.cinoton-product-reviews__load-more');

    if (!nativeNext) {
      if (button) button.remove();
      paginate.classList.toggle(
        'cinoton-product-reviews__paginate--complete',
        body.dataset.cinotonAccumulatedReviews === 'true'
      );
      return;
    }

    paginate.classList.remove('cinoton-product-reviews__paginate--complete');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'jdgm-btn jdgm-btn--solid cinoton-product-reviews__load-more';
      button.textContent = 'Load More';
      button.addEventListener('click', function () {
        beginPaginationLoad(button, widget);
      });
      paginate.appendChild(button);
    }

    if (!body.id) body.id = 'CinotonReviewList-' + Math.random().toString(36).slice(2, 9);
    button.setAttribute('aria-controls', body.id);
  }

  function makeTab(index, original) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cinoton-product-reviews__tab';
    button.dataset.cinotonReviewTab = String(index);
    button.addEventListener('click', function () {
      var root = button.closest('.cinoton-product-reviews');
      var sourceIndex = Number(button.dataset.cinotonReviewTab);
      var source = root && root.querySelectorAll('.jdgm-subtab__name')[sourceIndex];
      if (source) {
        source.click();
        scheduleEnhance();
      }
    });
    syncTab(button, original);
    return button;
  }

  function syncTab(button, original) {
    if (!button || !original) return;
    var label = (original.textContent || '').trim();
    if (button.textContent !== label) button.textContent = label;
    button.setAttribute('aria-pressed', original.classList.contains('jdgm--active') ? 'true' : 'false');
  }

  function ensureTopbar(root, widget) {
    var topbar = root.querySelector('.cinoton-product-reviews__topbar');
    if (!topbar) {
      topbar = document.createElement('div');
      topbar.className = 'cinoton-product-reviews__topbar';
      topbar.innerHTML = '<h2 class="cinoton-product-reviews__heading">Reviews</h2><div class="cinoton-product-reviews__tabs" role="group" aria-label="Review content"></div>';
      root.insertBefore(topbar, root.firstChild);
    }

    var tabs = topbar.querySelector('.cinoton-product-reviews__tabs');
    var originals = widget.querySelectorAll('.jdgm-subtab__name');

    while (tabs.children.length > originals.length) {
      tabs.lastElementChild.remove();
    }

    originals.forEach(function (original, index) {
      var button = tabs.querySelector('[data-cinoton-review-tab="' + index + '"]');
      if (!button) {
        button = makeTab(index, original);
        tabs.appendChild(button);
      } else {
        button.dataset.cinotonReviewTab = String(index);
        syncTab(button, original);
      }
    });

    tabs.hidden = originals.length === 0;
  }

  function ensureSummary(widget) {
    var summary = widget.querySelector('.cinoton-product-reviews__summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'cinoton-product-reviews__summary';
      summary.innerHTML = '<h3>Customer feedback</h3><p>Browse ratings and real customer experiences. Shared media and product Q&amp;A appear when available.</p><div class="cinoton-product-reviews__chips" aria-label="Available review content"></div>';
      widget.insertBefore(summary, widget.firstChild);
    }

    var features = ['Ratings & reviews'];
    if (widget.querySelector('.jdgm-gallery__thumbnail, .jdgm-rev__pic-link, .jdgm-rev__video')) {
      features.push('Customer media');
    }
    if (widget.querySelector('.jdgm-quest-widg__body')) {
      features.push('Product Q&A');
    }

    var chips = summary.querySelector('.cinoton-product-reviews__chips');
    var signature = features.join('|');
    if (chips.dataset.features !== signature) {
      chips.dataset.features = signature;
      chips.replaceChildren();
      features.forEach(function (feature) {
        var chip = document.createElement('span');
        chip.className = 'cinoton-product-reviews__chip';
        chip.textContent = feature;
        chips.appendChild(chip);
      });
    }
  }

  function orderedNodes(widget, selectors) {
    var nodes = [];
    selectors.forEach(function (selector) {
      widget.querySelectorAll(selector).forEach(function (node) {
        if (nodes.indexOf(node) === -1) nodes.push(node);
      });
    });
    return nodes;
  }

  function placeNodes(container, nodes) {
    nodes.forEach(function (node, index) {
      var current = container.children[index];
      if (current !== node) container.insertBefore(node, current || null);
    });
  }

  function ensureLayout(widget) {
    var layout = widget.querySelector(':scope > .cinoton-product-reviews__layout');
    if (!layout) {
      layout = document.createElement('div');
      layout.className = 'cinoton-product-reviews__layout';
      layout.innerHTML = '<aside class="cinoton-product-reviews__sidebar"></aside><div class="cinoton-product-reviews__content"></div>';
      widget.appendChild(layout);
    }

    var sidebar = layout.querySelector(':scope > .cinoton-product-reviews__sidebar');
    var content = layout.querySelector(':scope > .cinoton-product-reviews__content');

    placeNodes(sidebar, orderedNodes(widget, [
      '.jdgm-rev-widg__summary',
      '.jdgm-histogram',
      '.jdgm-widget-actions-wrapper'
    ]));

    placeNodes(content, orderedNodes(widget, [
      '.cinoton-product-reviews__summary',
      '.jdgm-row-media',
      '.jdgm-row-actions',
      '.jdgm-form-wrapper',
      '.jdgm-question-form-wrapper',
      '.jdgm-form-dynamic-wrapper',
      '.jdgm-rev-widg__body',
      '.jdgm-quest-widg__body',
      '.jdgm-rev-widg__paginate-spinner-wrapper'
    ]));

    var media = content.querySelector(':scope > .jdgm-row-media');
    if (media) {
      var hasGalleryMedia = !!media.querySelector('.jdgm-gallery__thumbnail, .jdgm-rev__pic-link, .jdgm-rev__video');
      var medals = media.querySelector('.jdgm-medals-wrapper');
      var hasMedalContent = !!(medals && (
        medals.querySelector('img, svg, canvas') ||
        (medals.textContent || '').trim()
      ));
      media.classList.toggle('cinoton-product-reviews__empty-media', !hasGalleryMedia && !hasMedalContent);
    }
  }

  function observeWidget(widget) {
    if (observedWidgets.has(widget)) return;
    observedWidgets.add(widget);
    widgetObserver.observe(widget, {
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  function enhanceWidget(widget) {
    var root = widget.closest('.shopify-section') || widget.parentElement;
    if (!root) return;
    root.classList.add('cinoton-product-reviews');
    ensureTopbar(root, widget);
    ensureSummary(widget);
    ensureLayout(widget);
    ensurePersistentPagination(widget);
    observeWidget(widget);
  }

  function enhanceAll() {
    scheduled = false;
    var widgets = document.querySelectorAll('.jdgm-rev-widg');
    widgets.forEach(enhanceWidget);
  }

  function enhanceAddedWidgets(mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('.jdgm-rev-widg')) enhanceWidget(node);
        node.querySelectorAll('.jdgm-rev-widg').forEach(enhanceWidget);
      });
    });
  }

  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhanceAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnhance);
  } else {
    scheduleEnhance();
  }

  bootstrapObserver = new MutationObserver(enhanceAddedWidgets);
  bootstrapObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', scheduleEnhance);
})();
